<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <Transition
    appear
    mode="out-in"
    name="slide-fade"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </Transition>
</template>
<script>

export default {
  name: 'SlideFadeTransition'
}
</script>
